import { memo } from "react";
import { Link } from "react-router-dom";

import Breadcrumbs from "@mui/material/Breadcrumbs";
import Breadcrumb from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import ServiceConnectionInstructions from "components/ServiceConnectionInstructions";

import JiraAddAppPhase from "./Phase/AddAppPhase";

const JiraConnectSetupPage = memo(function JiraConnectSetupPage() {
  return (
    <>
      <Breadcrumbs>
        <Breadcrumb
          underline="none"
          color="inherit"
          component={Link}
          to="/environment/destinations"
        >
          Environment
        </Breadcrumb>
        <Breadcrumb
          underline="none"
          color="inherit"
          component={Link}
          to="/environment/destinations"
        >
          Destinations
        </Breadcrumb>
        <span />
      </Breadcrumbs>
      <ServiceConnectionInstructions label="Jira Cloud Issue Sync">
        <Stack spacing={2}>
          <Typography variant="body1" fontWeight="bold">
            How Jira Cloud Issue Sync works:
          </Typography>
          <Typography variant="body1">
            Jira Cloud Issue Sync allows the ThreatKey platform to connect to a
            Jira Cloud instance, synchronizing ThreatKey findings with issues in
            a Jira project in near real-time. When a finding is created or
            updated in ThreatKey, a corresponding issue is created or updated in
            a configured Jira project.
          </Typography>
          <Typography variant="body1">
            Sync can be configured to be bidirectional, such that status changes
            made to an associated issue in Jira are be reflected in the
            ThreatKey finding.
          </Typography>
          <Typography variant="body1">
            For more details on how this works - including information relevant
            to experienced Jira administrators and power users - please
            reference our{" "}
            <a
              href="https://docs.threatkey.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              issue sync documentation
            </a>
            .
          </Typography>
        </Stack>
      </ServiceConnectionInstructions>
      <JiraAddAppPhase />
    </>
  );
});

export default JiraConnectSetupPage;
